import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import SubmenuSuppliers from '../submenu/SubmenuSuppliers'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SupplyBillList from './SupplyBillList'
import SupplyBillsFilters from './filters/SupplyBillsFilters'
import SupplyBillsOptions from './options/SupplyBillsOptions'

const SupplyBills = () => {
  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuSuppliers />
		</MyBlock>
		<MyBlockHeader
            header={'Рахунки на оплату'}
            options={
                <SupplyBillsOptions />
            }
        />
		<MyBlock>
            <SupplyBillsFilters />
        </MyBlock>
		<MyBlock>
			<SupplyBillList />
		</MyBlock>
    </LayoutMain>
  )
}

export default SupplyBills